"use strict";

import React, { Component, PropTypes } from 'react';
import { Row, Col, Checkbox } from 'react-bootstrap';
import { Joi, Validation } from 'react-validation-decorator';
import { WithContext as ReactTags } from 'react-tag-input';
import QuestionTitleInput from '../../Question-Search';

import TagActions from '../../../actions/TagActions';
import TagStore from '../../../stores/TagStore';

class QuestionPopupForm extends Component {

  constructor() {
    super();
    this.state = {
      tags: [],
      suggestions: [],
      title: '',
      text: '',
      isAnonymous:false,
      _id:'',
      tagFor: 'newQuestion',
      copiedFrom:null
    };

    this._handleInputChange = this._handleInputChange.bind(this);
    this._handleSearchInput = this._handleSearchInput.bind(this);
    this._isFormValid = this._isFormValid.bind(this);
    this._handleQuestionChange=this._handleQuestionChange.bind(this);

    //todo autocomplete prop when true ignores the suggestion clicked on from the list and picks the first by deault.
    // it should work with delimiter such as enter or tab, but should not work with click;
    this._handleAddition= this._handleAddition.bind(this);
    this._handleDelete = this._handleDelete.bind(this);
    this._handleDrag = this._handleDrag.bind(this);

    this._handleTagStore = this._handleTagStore.bind(this);
  };

  componentWillMount(){
    TagStore.listen(this._handleTagStore);

    if(this.props.editQuestionPopup){
      if(this.props.editQuestionPopup.tags && this.props.editQuestionPopup.tags.length){
        this.props.editQuestionPopup.tags.map((tag,idx) => tag.id=(idx+1))
      }
      this.setState({
        title : this.props.editQuestionPopup.title || {},
        copiedFrom : this.props.editQuestionPopup.copiedFrom || null,
        text: this.props.editQuestionPopup.text || '',
        tags: this.props.editQuestionPopup.tags || [],
        _id: this.props.editQuestionPopup._id || '',
        tagFor: this.props.editQuestionPopup._id || 'newQuestion',
        isAnonymous: this.props.editQuestionPopup.isAnonymous || false
      }, () => {
          this.validate('title');
          this.validate('text');
          this._isFormValid();
      })
    }
  }

  componentWillUnmount(){
    TagStore.unlisten(this._handleTagStore);
  }

  static propTypes = {
    isValid: PropTypes.func.isRequired
  };

  validationSchema = Joi.object().keys({
    title: Joi.string().min(8).max(500).required().label('Question title'),
    text: Joi.string().allow("").max(1000).label('Question detail'),
    isAnonymous: Joi.boolean().label('isAnonymous')
  });


  render() {
    return (
      <form name="QuestionPopupFrm" noValidate className="form-tags">
        <Row>
          <Col md={12}>
            <div className={this.getValidationClassName('title')}>
              <label>Title</label>
              <QuestionTitleInput className='form-control'
                ref={elem => this.questionTitleInput = elem}
                value={this.state.title}
                onChange={this._handleQuestionChange}
                onSelection={this._handleSearchInput.bind(this, 'title')} />
              {this.renderValidationMessages('title')}
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <div className={this.getValidationClassName('text')}>
              <label>Text</label>
              <textarea className='form-control'
                value={this.state.text && this.state.text}
                placeholder="Enter question detail..."
                onChange={this._handleInputChange.bind(this, 'text')} />
              {this.renderValidationMessages('text')}
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <div className='form-group rem-tag-transform'>
              <label>Tags</label>
              <ReactTags tags={this.state.tags}
                suggestions={this.state.suggestions}
                handleDelete={this._handleDelete}
                handleAddition={this._handleAddition}
                handleDrag={this._handleDrag}
                handleInputChange={this._handleTagInputChange.bind(this)}
                handleFilterSuggestions={() => this.state.suggestions} />
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Checkbox checked={this.state.isAnonymous}
              onChange={this._handleInputChange.bind(this, 'isAnonymous')}>
              Ask question anonymously </Checkbox>
          </Col>
        </Row>
      </form>
    );
  };

  _handleQuestionChange(value) {
    this.setState({title: value}, () => {
      this.validate("title");
      this._isFormValid();
    })
  }

  _handleSearchInput(formInput, value) {
    let tags = this.state.tags.slice(0);
    value.tags.map(tag=>{
      !tags.find(t=>t._id===tag._id) ? tags.push(tag) : ""
    });
    this.setState({
      [formInput] : value.title,
      copiedFrom: value._id,
      tags: tags
    }, () => {
      this.validate(formInput);
      this._isFormValid();
    });
  }

  _handleInputChange(formInput, event) {
    let value = event.target.value;
    formInput === "isAnonymous"
      ? value = !this.state.isAnonymous: null;
    this.setState({[formInput]: value}, () => {
      this.validate(formInput);
      this._isFormValid();
    })
  };

  _handleTagInputChange(tag){
    TagActions.getSuggestions({text:tag});
  }

  _handleDelete(i) {
    let tags = this.state.tags.slice(0);
    tags.splice(i, 1);
    this.setState({tags: tags});
  }

  _handleAddition(tag) {
    TagActions.addChildTag({text:tag},this.state.tagFor);
  }

  _handleDrag(tag, currPos, newPos) {
    let tags = this.state.tags.slice(0);
    // mutate array
    tags.splice(currPos, 1);
    tags.splice(newPos, 0, tag);

    // re-render
    this.setState({ tags: tags });
  }

  _handleTagStore(state){
    if(state._newTag && state._newTag.tagFor===this.state.tagFor){
      let tags=this.state.tags.slice(0), newTag=state._newTag;
      tags.findIndex(t=> t._id===newTag._id) === -1
        ? tags.push({
          id: tags.length+1,
          _id: newTag._id,
          text: newTag.text
        })
        : "";
      this.setState({tags:tags});
    }

    if(this.state.tags && this.state.tags.length===0 && state._popupTags && state._popupTags[this.state.tagFor] && state._popupTags[this.state.tagFor].length){
      this.setState({
        tags: state._popupTags[this.state.tagFor]
      })
    }
    this.setState({
      suggestions: state._suggestions.filter(sugg => {
        return this.state.tags.findIndex(tag => tag._id == sugg._id) == -1
      }).map(sugg => sugg.text)
    })
  }

  _isFormValid() {
    this.props.isValid(!this.state.validation.errors.length);
  }

  getModel() {
    const {title,tags,isAnonymous, text, _id, copiedFrom} = this.state;
    return({
      title:title,
      tags:tags.map(tag=>tag._id),
      text:text,
      isAnonymous:isAnonymous,
      _id:_id,
      copiedFrom: copiedFrom._id ? copiedFrom._id : copiedFrom 
    });
  }

  reset(){
    this.resetValidation();
    this.questionTitleInput.clear()
  }
}

export default Validation(QuestionPopupForm);
